import { MergedStep } from './MergedStep';
import { ExpertRules } from './ExpertRules';
import { useExpertRules } from './expertRulesStore';
import { PhaseControls } from './PhaseControls';
import { SectionNav } from './SectionNav';
import { SubphaseId } from './phaseBusy';
import { useStepParts } from './stepPartsRun';
import { useStepsRun } from './stepsRun';
import { StepPartsPanel } from './StepPartsPanel';
import { StepsBadge } from './StepsBadge';
import { usePlace } from './lastPlace';
import { useAllocStage, useSubstepsStage } from './stageProgress';
import { useLanguage } from '../../contexts/LanguageContext';
import { stepsView } from './appScreens';

// PHASE 4, THE STEPS, IN TWO SUBPHASES: the overview (which parts and tools each step adds, what
// it does, what it prints — one reader holding every step) and the sub-steps (each step broken
// into its gestures, one call per step, given the overview). They were two phases; the second
// half of each is the first half's answer read closer, and one badge runs and shows both.
//
// THE BADGE OVER THE SELECTOR, whichever subphase is open, as in every phase.
export function StepsSubphases({ docId, file, locked, held }: {
  docId: string; file: Blob; locked?: boolean; held?: boolean;
}) {
  const { t } = useLanguage();
  // Where this browser was inside the phase — see usePlace.
  const [saved, setView] = usePlace(docId, 'steps');
  const view = stepsView(saved);
  const overviewStage = useAllocStage(docId);
  const substepsStage = useSubstepsStage(docId);
  const alloc = useStepParts(docId);
  const steps = useStepsRun(docId);
  const { rules } = useExpertRules();
  return (
    <div className="flex flex-col gap-6">
      <PhaseControls>
        <StepsBadge docId={docId} file={file} locked={locked} />
      </PhaseControls>
      <SectionNav
        items={[
          // ONE BADGE RUNS BOTH (see StepsBadge), so each half says its own run.
          { id: 'overview', label: t('notice.steps.subOverview'), fraction: overviewStage.fraction, busy: alloc.busy },
          { id: 'substeps', label: t('notice.steps.subSteps'), fraction: substepsStage.fraction, busy: steps.busy },
          // THE EXPERT RULES (see ExpertRules): full where any is on.
          { id: 'rules', label: t('notice.steps.subRules'), fraction: rules.some((r) => r.enabled) ? 1 : 0 },
        ]}
        active={view}
        onSelect={setView}
      />
      <SubphaseId.Provider value={view}>
        {view === 'overview'
          ? <StepPartsPanel docId={docId} file={file} locked={locked} held={held} />
          : view === 'rules' ? <ExpertRules locked={locked} />
            : <MergedStep docId={docId} file={file} locked={locked} held={held} />}
      </SubphaseId.Provider>
    </div>
  );
}
